import { c as _c } from "react/compiler-runtime";
import { BackupPolicyType, ResourceType, VaultStorageTier } from '@repo/api-gw-sdk';
import { useCallback, useMemo } from 'react';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';
import { useSupportedResourceTypes } from '@/data/inventory/useSupportedResourceTypes';
import { COLD_TIER_SUPPORTED_RESOURCE_TYPES } from '@/utils/vaultStorageTier';
export type GetBackupPolicyAvailableTypes = (policyType: BackupPolicyType, vaultStorageTier: VaultStorageTier) => ResourceType[];
export function useBackupPolicyAvailableTypes() {
  const $ = _c(60);
  const {
    RdsHighFrequencyBackupEnabled,
    SapHanaPitrSupport,
    AzureSqlVirtualMachineSupport,
    GcpSqlVirtualMachineSupport,
    EnableBigQueryNativePolicy,
    MongoAtlasSupport,
    AwsRdsNativeBackupSupport,
    AwsEksClusterBackupSupport,
    GoogleWorkspaceSupport,
    Microsoft365Support,
    EntraIdSupport,
    AzureNativeVmBackupSupport,
    AwsEc2InAccountBackupSupport
  } = useFeatureFlags();
  const allTypes = useSupportedResourceTypes();
  let t0;
  if ($[0] !== RdsHighFrequencyBackupEnabled) {
    t0 = RdsHighFrequencyBackupEnabled ? [ResourceType.AwsRds] : [];
    $[0] = RdsHighFrequencyBackupEnabled;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== MongoAtlasSupport) {
    t1 = MongoAtlasSupport ? [ResourceType.AtlasMongodbCluster] : [];
    $[2] = MongoAtlasSupport;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = [ResourceType.AwsEc2, ResourceType.GcpComputeEngineInstance, ...t0, ResourceType.AwsDynamoDb, ResourceType.AwsKeyspacesTable, ResourceType.AwsS3, ResourceType.GcpCloudStorageBucket, ...t1];
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const HighFrequencySupportedResourceTypes = t2;
  let t3;
  if ($[7] !== AwsEc2InAccountBackupSupport) {
    t3 = [...(AwsEc2InAccountBackupSupport ? [ResourceType.AwsEc2] : [])];
    $[7] = AwsEc2InAccountBackupSupport;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const awsNativeHighFrequencySupportedResourceTypes = t3;
  let t4;
  if ($[9] !== AzureSqlVirtualMachineSupport) {
    t4 = AzureSqlVirtualMachineSupport ? [ResourceType.AzureSqlVirtualMachine] : [];
    $[9] = AzureSqlVirtualMachineSupport;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== GcpSqlVirtualMachineSupport) {
    t5 = GcpSqlVirtualMachineSupport ? [ResourceType.GcpSqlVm] : [];
    $[11] = GcpSqlVirtualMachineSupport;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== SapHanaPitrSupport) {
    t6 = SapHanaPitrSupport ? [ResourceType.AzureSapHanaVm, ResourceType.GcpSapHanaVm] : [];
    $[13] = SapHanaPitrSupport;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = [...t4, ...t5, ...t6];
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const pitrPolicySupportedResourceTypes = t7;
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [ResourceType.AwsRds];
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const nativePitrPolicySupportedResourceTypes = t8;
  let t9;
  if ($[20] !== EnableBigQueryNativePolicy) {
    t9 = [...(EnableBigQueryNativePolicy ? [ResourceType.GcpBigQuery] : [])];
    $[20] = EnableBigQueryNativePolicy;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const bigQueryNativePitrSupportedResourceTypes = t9;
  let t10;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = [ResourceType.AzureSqlDatabase];
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const azureSqlDatabaseNativePitrSupportedResourceTypes = t10;
  let t11;
  if ($[23] !== AwsRdsNativeBackupSupport) {
    t11 = AwsRdsNativeBackupSupport ? [ResourceType.AwsRds] : [];
    $[23] = AwsRdsNativeBackupSupport;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== AwsEksClusterBackupSupport) {
    t12 = AwsEksClusterBackupSupport ? [ResourceType.AwsEksCluster] : [];
    $[25] = AwsEksClusterBackupSupport;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t11 || $[28] !== t12) {
    t13 = [ResourceType.AwsFsx, ResourceType.AwsEfs, ResourceType.AwsDocumentdb, ResourceType.AwsNeptune, ...t11, ...t12];
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  const awsNativeStandardPolicySupportedResourceTypes = t13;
  let t14;
  if ($[30] !== AzureNativeVmBackupSupport) {
    t14 = [ResourceType.AzureFileShare, ...(AzureNativeVmBackupSupport ? [ResourceType.AzureVirtualMachine] : [])];
    $[30] = AzureNativeVmBackupSupport;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  const azureFilesPolicySupportedResourceTypes = t14;
  let t15;
  if ($[32] !== GoogleWorkspaceSupport) {
    t15 = [...(GoogleWorkspaceSupport ? [ResourceType.GoogleWorkspaceResource] : [])];
    $[32] = GoogleWorkspaceSupport;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  const googleWorkspacePolicySupportedResourceTypes = t15;
  let t16;
  if ($[34] !== Microsoft365Support) {
    t16 = [...(Microsoft365Support ? [ResourceType.Microsoft365Resource] : [])];
    $[34] = Microsoft365Support;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  const microsoft365PolicySupportedResourceTypes = t16;
  let t17;
  if ($[36] !== EntraIdSupport) {
    t17 = [...(EntraIdSupport ? [ResourceType.AzureEntraIdResource] : [])];
    $[36] = EntraIdSupport;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  const entraIdPolicySupportedResourceTypes = t17;
  let t18;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = [ResourceType.AwsRds, ResourceType.AzureVirtualMachine];
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  const dualSupportedResourceTypes = t18;
  let t19;
  if ($[39] !== allTypes || $[40] !== awsNativeStandardPolicySupportedResourceTypes || $[41] !== azureFilesPolicySupportedResourceTypes) {
    let t20;
    if ($[43] !== awsNativeStandardPolicySupportedResourceTypes || $[44] !== azureFilesPolicySupportedResourceTypes) {
      t20 = type => (!awsNativeStandardPolicySupportedResourceTypes.includes(type) || dualSupportedResourceTypes.includes(type)) && (!azureFilesPolicySupportedResourceTypes.includes(type) || dualSupportedResourceTypes.includes(type)) && type !== ResourceType.GoogleWorkspaceResource && type !== ResourceType.Microsoft365Resource && type !== ResourceType.AzureEntraIdResource;
      $[43] = awsNativeStandardPolicySupportedResourceTypes;
      $[44] = azureFilesPolicySupportedResourceTypes;
      $[45] = t20;
    } else {
      t20 = $[45];
    }
    t19 = [...allTypes.filter(t20)];
    $[39] = allTypes;
    $[40] = awsNativeStandardPolicySupportedResourceTypes;
    $[41] = azureFilesPolicySupportedResourceTypes;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  const standardPolicySupportedResourceTypes = t19;
  let t20;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = [];
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== HighFrequencySupportedResourceTypes || $[48] !== awsNativeHighFrequencySupportedResourceTypes || $[49] !== awsNativeStandardPolicySupportedResourceTypes || $[50] !== azureFilesPolicySupportedResourceTypes || $[51] !== bigQueryNativePitrSupportedResourceTypes || $[52] !== entraIdPolicySupportedResourceTypes || $[53] !== googleWorkspacePolicySupportedResourceTypes || $[54] !== microsoft365PolicySupportedResourceTypes || $[55] !== pitrPolicySupportedResourceTypes || $[56] !== standardPolicySupportedResourceTypes) {
    t21 = {
      [BackupPolicyType.BACKUP_POLICY_TYPE_HIGH_FREQUENCY]: HighFrequencySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AWS_NATIVE_HIGH_FREQUENCY]: awsNativeHighFrequencySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_PITR]: pitrPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AWS_NATIVE_PITR]: nativePitrPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_STANDARD]: standardPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AWS_NATIVE_STANDARD]: awsNativeStandardPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_BIGQUERY_NATIVE_PITR]: bigQueryNativePitrSupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_SQL_DATABASE_NATIVE_PITR]: azureSqlDatabaseNativePitrSupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_FILES]: azureFilesPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_GOOGLE_WORKSPACE]: googleWorkspacePolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_MICROSOFT_365]: microsoft365PolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_ENTRA_ID]: entraIdPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_UNSPECIFIED]: t20
    };
    $[47] = HighFrequencySupportedResourceTypes;
    $[48] = awsNativeHighFrequencySupportedResourceTypes;
    $[49] = awsNativeStandardPolicySupportedResourceTypes;
    $[50] = azureFilesPolicySupportedResourceTypes;
    $[51] = bigQueryNativePitrSupportedResourceTypes;
    $[52] = entraIdPolicySupportedResourceTypes;
    $[53] = googleWorkspacePolicySupportedResourceTypes;
    $[54] = microsoft365PolicySupportedResourceTypes;
    $[55] = pitrPolicySupportedResourceTypes;
    $[56] = standardPolicySupportedResourceTypes;
    $[57] = t21;
  } else {
    t21 = $[57];
  }
  const supportedResourceTypes = t21;
  const policySupportedResourceTypes = supportedResourceTypes;
  let t22;
  if ($[58] !== policySupportedResourceTypes) {
    t22 = (policyType, vaultStorageTier) => {
      const availableTypes = policySupportedResourceTypes[policyType];
      return vaultStorageTier === VaultStorageTier.VAULT_STORAGE_TIER_COLD ? availableTypes.filter(_temp) : availableTypes;
    };
    $[58] = policySupportedResourceTypes;
    $[59] = t22;
  } else {
    t22 = $[59];
  }
  return t22;
}
function _temp(resourceType) {
  return COLD_TIER_SUPPORTED_RESOURCE_TYPES.includes(resourceType);
}